module.exports = __webpack_public_path__ + "static/img/OHSAS18001_Renwu_mobile.03e7d3c6.jpg";